/* LYVOI: preselect the cart "Complete the set" upsell to the size that completes the set, in the color already in the cart.
   Cart has a carry-on (20/22) -> suggest 28" Check in; cart has a big case (28/30) -> suggest 20" Carry on (10-12 fix:
   it used to always suggest 28", even with a 28" already in the cart). Copy is swapped to match.
   Upsell block renders the product's first variant (20" Silver) by default; this just changes the dropdowns
   and fires the theme's own change handler, so price/variant id update through theme code. */
(function () {
  var sizeWanted = '28';
  var cartColor = null;
  var suitcaseCount = 0;
  var COPY_BIG = 'Most customers pair a checked case with a 20″ carry-on. <strong>Add a second case and get 15% off the lower-priced one.</strong>';

  function loadCartColor() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cases = (cart.items || []).filter(function (i) { return /suitcase/i.test(i.product_title || ''); });
        suitcaseCount = cases.reduce(function (n, i) { return n + i.quantity; }, 0);
        var item = cases[0];
        cartColor = item && item.options_with_values
          ? (item.options_with_values.find(function (o) { return /colou?r/i.test(o.name); }) || {}).value || null
          : null;
        var hasBig = cases.some(function (i) { return /28|30/.test(i.variant_title || ''); });
        sizeWanted = hasBig ? '20' : '28';
      })
      .catch(function () {});
  }

  function pick(select, test) {
    var opt = Array.prototype.find.call(select.options, function (o) { return !o.disabled && test(o.value); });
    if (opt && select.value !== opt.value) {
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply(picker) {
    if (picker.dataset.lyvoiDefaulted) return;
    picker.dataset.lyvoiDefaulted = '1';
    picker.querySelectorAll('select').forEach(function (s) {
      var name = s.getAttribute('name') || '';
      if (/colou?r/i.test(name) && cartColor) pick(s, function (v) { return v === cartColor; });
    });
    picker.querySelectorAll('select').forEach(function (s) {
      var name = s.getAttribute('name') || '';
      if (/size/i.test(name)) pick(s, function (v) { return v.indexOf(sizeWanted) !== -1; });
    });
    if (sizeWanted === '20') {
      var card = picker.closest('cart-drawer-upsell') || picker.parentElement;
      var desc = card && Array.prototype.find.call(card.querySelectorAll('p, div, span'), function (e) {
        return e.children.length <= 1 && /Most customers pair/.test(e.innerHTML);
      });
      if (desc) desc.innerHTML = COPY_BIG;
    }
  }

  function scan() {
    // Copy promises "15% off the lower-priced one" (2ND CASE 15% OFF): only meaningful while the cart has a single case.
    document.querySelectorAll('cart-drawer .upsell__variant-picker, #CartDrawer .upsell__variant-picker, .cart-drawer .upsell__variant-picker')
      .forEach(function (p) {
        var block = p.closest('.cart-drawer-upsells-container') || p.closest('cart-drawer-upsell');
        if (block) block.style.display = suitcaseCount >= 2 ? 'none' : '';
      });
    document.querySelectorAll('cart-drawer .upsell__variant-picker, #CartDrawer .upsell__variant-picker, .cart-drawer .upsell__variant-picker')
      .forEach(apply);
    setTimeout(syncPrices, 50);
  }

  // .com's older upsell block switches data-id on variant change but never repaints the price
  // (showed $220 while adding the $340 28"). Repaint from the block's own variants JSON.
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function syncPrices() {
    document.querySelectorAll('cart-drawer-upsell').forEach(function (u) {
      try {
        var js = u.querySelector('script[type="application/json"]');
        var v = JSON.parse(js.textContent).find(function (x) { return String(x.id) === String(u.dataset.id); });
        var rp = u.querySelector('.upsell__price .regular-price'), cp = u.querySelector('.upsell__price .compare-price');
        if (v && rp) rp.textContent = money(v.price);
        if (v && cp && v.compare_at_price) cp.textContent = money(v.compare_at_price);
      } catch (e) {}
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer-upsell')) setTimeout(syncPrices, 50);
  }, true);

  new MutationObserver(function () {
    if (document.querySelector('.upsell__variant-picker:not([data-lyvoi-defaulted])')) loadCartColor().then(scan);
  }).observe(document.documentElement, { childList: true, subtree: true });

  loadCartColor().then(scan);
})();
